import { render, staticRenderFns } from "./SaitenFuriwakes.vue?vue&type=template&id=049696c0&scoped=true&lang=pug&"
import script from "./SaitenFuriwakes.vue?vue&type=script&lang=ts&"
export * from "./SaitenFuriwakes.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenFuriwakes.vue?vue&type=style&index=0&id=049696c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049696c0",
  null
  
)

component.options.__file = "SaitenFuriwakes.vue"
export default component.exports